var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspirationorange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.5H10.5M6 11.25H12M3.75 6.75C3.75 5.35761 4.30312 4.02226 5.28769 3.03769C6.27226 2.05312 7.60761 1.5 9 1.5C10.3924 1.5 11.7277 2.05312 12.7123 3.03769C13.6969 4.02226 14.25 5.35761 14.25 6.75C14.2505 7.5953 14.0461 8.42813 13.6542 9.17712C13.2623 9.9261 12.6947 10.5689 12 11.0505L11.5935 12.975C11.5397 13.3297 11.3605 13.6534 11.0885 13.8873C10.8164 14.1213 10.4695 14.2499 10.1108 14.25H7.88925C7.53046 14.2499 7.18359 14.1213 6.91154 13.8873C6.6395 13.6534 6.46032 13.3297 6.4065 12.975L6 11.0587C5.30506 10.5755 4.73743 9.93114 4.34561 9.18082C3.9538 8.43049 3.74944 7.59647 3.75 6.75V6.75Z",
    stroke: "#EE9A8F",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspirationorange);
export default __webpack_public_path__ + "static/media/Inspirationorange.d4b2dfcbdbc4e0590b24b9d478749a24.svg";
export { ForwardRef as ReactComponent };